import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import {
  TrlFormControlLabel,
  TrlRadioButton,
  TrlScreenSummary,
  TrlTextWithLink,
} from '»components/atoms';

import { ContainerStyled, FormControlStyled } from './TrlRadioOptions.styles';

export const TrlRadioOptions = ({
  title,
  descr,
  options,
  selectedOptionId,
  handleChange,
  width,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <ContainerStyled width={width}>
      {isMobile ? (
        <TrlScreenSummary title={title} hasTopMargin>
          <TrlTextWithLink mainText={descr} />
        </TrlScreenSummary>
      ) : (
        <TrlTextWithLink mainText={descr} />
      )}
      <FormControlStyled>
        {options.map((option) => {
          const { id, label } = option;

          return (
            <TrlFormControlLabel
              key={id}
              id={id}
              label={label}
              selectedOptionId={selectedOptionId}
            >
              <TrlRadioButton
                id={id}
                name={id}
                value={id}
                selectedValue={selectedOptionId}
                onChange={handleChange}
              />
            </TrlFormControlLabel>
          );
        })}
      </FormControlStyled>
    </ContainerStyled>
  );
};

TrlRadioOptions.propTypes = {
  title: PropTypes.string.isRequired,
  descr: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedOptionId: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  width: PropTypes.string,
};
